import api from "./api";
import { Partner } from "../contexts/PartnerContext";

export const uploadFile = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post(`/upload/partners`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.path;
};

export const createPartner = async (
  name: string,
  imageFile: File
): Promise<Partner> => {
  // 1. Upload image
  const imagePath = await uploadFile(imageFile);

  // 2. Create partner with image path
  const { data } = await api.post("/partners", {
    name,
    image: imagePath,
  });
  return data;
};

export const getPartners = async (): Promise<Partner[]> => {
  const { data } = await api.get("/partners");
  return data;
};

export const deletePartner = async (id: string): Promise<Partner> => {
  const { data } = await api.delete(`/partners/${id}`);
  return data;
};
